
export const RHINO_IMAGE = "https://deposify-public-cdn.s3.us-east-2.amazonaws.com/site/images/rhino/rhino_logo.svg";
export const RHINO_COLOUR = "#6b3bf6"